module.exports = __webpack_public_path__ + "static/sys_ph08-f564bb7355e5ebd288177725a670068b.jpg";